import React from 'react';
import CloudDownload from '@material-ui/icons/CloudDownload';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LinkIcon from '@material-ui/icons/Link';
import { useBitriseArtifactDetails } from '../useBitriseArtifactDetails.esm.js';
import Alert from '@material-ui/lab/Alert';

const BitriseDownloadArtifactComponent = ({
  appSlug,
  buildSlug,
  artifactSlug
}) => {
  const { value, loading, error } = useBitriseArtifactDetails(
    appSlug,
    buildSlug,
    artifactSlug
  );
  if (loading) {
    return /* @__PURE__ */ React.createElement(CircularProgress, null);
  }
  if (error) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "error" }, error.message);
  }
  if (!value?.public_install_page_url && !value?.expiring_download_url) {
    return /* @__PURE__ */ React.createElement(Alert, { severity: "warning" }, "Cannot be installed/downloaded.");
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !!value.public_install_page_url && /* @__PURE__ */ React.createElement(Tooltip, { title: "Install" }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      href: value.public_install_page_url,
      target: "_blank",
      rel: "noopener"
    },
    /* @__PURE__ */ React.createElement(LinkIcon, null)
  )), !!value.expiring_download_url && /* @__PURE__ */ React.createElement(Tooltip, { title: "Download" }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      href: value.expiring_download_url,
      target: "_blank",
      rel: "noopener"
    },
    /* @__PURE__ */ React.createElement(CloudDownload, null)
  )));
};

export { BitriseDownloadArtifactComponent };
//# sourceMappingURL=BitriseDownloadArtifactComponent.esm.js.map
